import { isResidentialBien, isLandBien } from "../Services/bienEditModel";
import React from 'react';
import { useTranslation } from 'react-i18next';
 
const SectionEdit = ({ formData , onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
       <div className="grid grid-cols-1 md:grid-cols-1 gap-6"> 
              </div>
              <div className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-6">
            
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-1 gap-6">
                <div>
                  {/* Sale <-> rent switch (vacation listings use another form; other types are not offered). */}
                  {["sale", "rent"].includes(String(formData.type || "").toLowerCase()) && (
                    <>
                      <p className="mt-4 text-lg font-semibold">{t("sell / rent")}</p>
                      <div className="mt-4 flex space-x-2" role="group" aria-label={t("sell / rent")}>
                        {[["sale", t("sell")], ["rent", t("rent")]].map(([value, label]) => {
                          const active = String(formData.type).toLowerCase() === value;
                          return (
                            <button key={value} type="button" id="type" value={value} onClick={onChange} aria-pressed={active}
                              className={`w-1/5 px-2 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                                active ? "bg-white text-black" : "bg-slate-600 text-white"
                              }`}>
                              {label}
                            </button>
                          );
                        })}
                      </div>
                    </>
                  )}
                  <p className="mt-4 text-lg font-semibold">
                    {t("choose_property_type")}{" "}
                  </p>
                  <div className="mt-4 flex space-x-2">
                    <button
                      type="button"
                      id="category"
                      value="Appartement"
                      onClick={onChange}
                      className={`w-1/5 px-2 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                        formData.category === "Appartement"
                          ? "bg-white text-black"
                          : "bg-slate-600 text-white"
                      }`}
                    >
                      {t("apartment")}
                    </button>
                    <button
                      type="button"
                      id="category"
                      value="Maison"
                      onClick={onChange}
                      className={`w-1/5 px-2 py-1 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                        formData.category === "Maison"
                          ? "bg-white text-black"
                          : "bg-slate-600 text-white"
                      }`}
                    >
                      {t("house")}
                    </button>
                    <button
                      type="button"
                      id="category"
                      value="commercial"
                      onClick={onChange}
                      className={`w-1/5 px-2 py-1 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                       String(formData.category).toLowerCase() === "commercial"
                          ? "bg-white text-black"
                          : "bg-slate-600 text-white"
                      }`}
                    >
                      {t("commercial")}
                    </button>
                    <button
                      type="button"
                      id="category"
                      value="Terrain"
                      onClick={onChange}
                      className={`w-1/5 px-2 py-1 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                        formData.category === "Terrain"
                          ? "bg-white text-black"
                          : "bg-slate-600 text-white"
                      }`}
                    >
                      {t("land")}
                    </button>
                    <button
                      type="button"
                      id="category"
                      value="Autres"
                      onClick={onChange}
                      className={`w-1/5 px-2 py-1 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                       formData.category === "Autres"
                          ? "bg-white text-black"
                          : "bg-slate-600 text-white"
                      }`}
                    >
                      {t("others")}
                    </button>
                  </div>
                </div>
              </div>

              
              </div>
        
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    className="block text-lg font-semibold"
                    htmlFor="libelle"
                  >
                    {t("label")}
                  </label>
                  <input
                    required
                    type="text"
                    id="libelle"
                    value={formData.libelle ?? ""}
                    onChange={onChange}
                    className="w-full px-4 py-2 text-lg border border-gray-300 rounded"
                  />
                  <div>
                    <label
                      className="block text-lg font-semibold"
                      htmlFor="surface"
                    >
                      {t("surface")}
                    </label>
                    <input
                      type="number"
                      id="surface"
                      min={0}
                      value={Number(formData.surface) === 0 ? "" : formData.surface ?? ""}
                      onChange={onChange}
                      className="w-1/3 px-4 py-2 text-lg border border-gray-300 rounded"
                    />
                  </div>
                </div>
                <div>
                  <label
                    className="block text-lg font-semibold"
                    htmlFor="description"
                  >
                    {t("listing.description")}
                  </label>
                  <textarea
                    id="description"
                    value={formData.description ?? ""}
                    onChange={onChange}
                    className="w-full px-4 py-2 text-lg border border-gray-300 rounded h-32"
                  />
                </div>
              </div> 
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {isResidentialBien(formData.category) && (
                  <div>
                    <p className="text-lg font-semibold">{t('bedrooms')}</p>
                    <input
                      type="number"
                      id="chambres"
                      value={formData.chambres ?? ""}
                      onChange={onChange}
                      min="0"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                  )}
                 
                  
                  {!isLandBien(formData.category) && (
                  <div>
                    <p className="text-lg font-semibold">{t('bathroom')}</p>
                    <input
                      type="number"
                      id="sallesBains"
                      value={formData.sallesBains ?? ""}
                      onChange={onChange}
                      min="0"
                      max="50"
                      required
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:text-gray-700 focus:bg-white focus:border-slate-600 text-center"
                    />
                  </div>
                  )}
                </div>
               
              {!isLandBien(formData.category) && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-lg font-semibold">
                      {t("parking")}
                    </label>
                    <div className="flex items-center space-x-4">
                      <button
                        type="button"
                        id="parking"
                        value={true}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          formData.parking
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("yes")}
                      </button>
                      <button
                        type="button"
                        id="parking"
                        value={false}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          !formData.parking
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("non")}
                      </button>
                    </div>
                  </div>
                  {isResidentialBien(formData.category) && (
                  <div>
                    <label className="block text-lg font-semibold">
                      {t("furnished")}
                    </label>
                    <div className="flex items-center space-x-4">
                      <button
                        type="button"
                        id="meuble"
                        value={true}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          formData.meuble
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("yes")}
                      </button>
                      <button
                        type="button"
                        id="meuble"
                        value={false}
                        onClick={onChange}
                        className={`w-1/2 px-4 py-2 font-medium text-sm uppercase shadow-md rounded hover:shadow-lg transition duration-150 ease-in-out ${
                          !formData.meuble
                            ? "bg-slate-600 text-white"
                            : "bg-white text-black"
                        }`}
                      >
                        {t("non")}
                      </button>
                    </div>
                  </div>
                  )}
                </div>
              )}

    </div>
  );
};

export default SectionEdit;
